const Rules = () => {
    return (
        <div className="content-container">
            <div className="rules dark-main-container">

                <h1>🎯 How to Play Burro Verde</h1>

                <section className="rules-section">
                    <h2>1. Make Your Predictions</h2>

                    <p>
                        Before each match starts, submit your prediction for:
                    </p>

                    <ul>
                        <li>
                            ⚽ <strong>Final score</strong> — predict the number
                            of goals scored by the home and away team.
                        </li>

                        <li>
                            ⏱️ <strong>Half-time result</strong>
                            <ul>
                                <li>
                                    <strong>1</strong> = Home team leads
                                </li>
                                <li>
                                    <strong>X</strong> = Draw
                                </li>
                                <li>
                                    <strong>2</strong> = Away team leads
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <p>
                        Your prediction must be saved
                        <strong> before kick-off</strong>.
                    </p>

                    <div className="rules-image">
                        <img
                            src="/predictions.png"
                            alt="Example of submitted predictions"
                        />
                    </div>

                    <p>
                        In the example above, the user predicts Real Madrid
                        to win 2:1 and predicts a half-time draw.
                        For Barcelona, the user predicts a 4:2 win and
                        Barcelona to lead at half-time.
                    </p>
                </section>


                <section className="rules-section">
                    <h2>🏆 How Points Are Awarded</h2>

                    <p>
                        You can earn points from four different categories
                        for every match.
                    </p>

                    <table className="rules-points-table">
                        <thead>
                            <tr>
                                <th>Prediction</th>
                                <th>Points</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>🎯 Exact final score</td>
                                <td>4</td>
                            </tr>

                            <tr>
                                <td>⏱️ Correct half-time result</td>
                                <td>1</td>
                            </tr>

                            <tr>
                                <td>➖ Correct goal difference</td>
                                <td>1–2</td>
                            </tr>

                            <tr>
                                <td>✅ Correct match outcome</td>
                                <td>3–7</td>
                            </tr>
                        </tbody>
                    </table>

                    <p>
                        Points from different categories are added together,
                        so a single prediction can earn points in multiple
                        categories.
                    </p>

                    <div className="rules-highlight">
                        Maximum possible score:
                        <strong> 13 points per match</strong>.
                    </div>

                    <p>
                        The number of points awarded for the correct match
                        outcome depends on how unexpected that outcome is.
                        Correctly predicting an upset earns more points than
                        correctly predicting the favorite.
                    </p>
                </section>


                <section className="rules-section">
                    <h2>📌 Match Outcome Points</h2>

                    <p>
                        A correct match outcome can earn between
                        <strong> 3 and 7 points</strong>.
                    </p>

                    <p>
                        The points are based on the pre-match chances of the
                        three possible outcomes:
                        <strong> Home win (1), Draw (X), or Away win (2)</strong>.
                    </p>

                    <p>
                        The less likely the predicted outcome is, the more
                        points you receive for getting it right.
                    </p>

                    <div className="rules-examples">

                        <div className="rules-example">
                            <h3>🇧🇷 Brazil vs 🇭🇹 Haiti</h3>

                            <p>
                                Brazil was a strong favorite, so correctly
                                predicting a Brazil win earns only
                                <strong> 3 points</strong>.
                            </p>

                            <div className="rules-image">
                                <img
                                    src="/brazil-haiti.png"
                                    alt="Brazil vs Haiti prediction example"
                                />
                            </div>
                        </div>


                        <div className="rules-example">
                            <h3>🇫🇷 France vs 🇸🇳 Senegal</h3>

                            <p>
                                France was still favored, but the match was
                                considered less one-sided. Correctly predicting
                                France to win earns
                                <strong> 4 points</strong>.
                            </p>

                            <div className="rules-image">
                                <img
                                    src="/france-senegal.png"
                                    alt="France vs Senegal prediction example"
                                />
                            </div>
                        </div>


                        <div className="rules-example">
                            <h3>🇳🇱 Netherlands vs 🇯🇵 Japan</h3>

                            <p>
                                A draw was less likely than a win for either
                                team, so correctly predicting the draw earns
                                <strong> 5 points</strong>.
                            </p>

                            <div className="rules-image">
                                <img
                                    src="/netherlands-japan.png"
                                    alt="Netherlands vs Japan prediction example"
                                />
                            </div>
                        </div>


                        <div className="rules-example">
                            <h3>🇦🇺 Australia vs 🇹🇷 Turkey</h3>

                            <p>
                                Australia was the underdog, so correctly
                                predicting an Australian win earns
                                <strong> 6 points</strong>.
                            </p>

                            <div className="rules-image">
                                <img
                                    src="/australia-turkey.png"
                                    alt="Australia vs Turkey prediction example"
                                />
                            </div>
                        </div>


                        <div className="rules-example">
                            <h3>🇪🇨 Ecuador vs 🇩🇪 Germany</h3>

                            <p>
                                Germany was the strong favorite, making an
                                Ecuador win an absolute upset. Correctly
                                predicting it earns the maximum
                                <strong> 7 points</strong>.
                            </p>

                            <div className="rules-image">
                                <img
                                    src="/ecuador-germany.png"
                                    alt="Ecuador vs Germany prediction example"
                                />
                            </div>
                        </div>

                    </div>
                </section>


                <section className="rules-section">
                    <h2>🎯 Exact Final Score</h2>

                    <p>
                        Predicting the exact final score earns
                        <strong> 4 points</strong>.
                    </p>

                    <p>
                        For example, if the match ends 2:1 and you predicted
                        2:1, you receive the 4 points.
                    </p>

                    <div className="rules-image">
                        <img
                            src="/spain-belgium.png"
                            alt="Exact score prediction example"
                        />
                    </div>

                    <p>
                        If your predicted score is not exactly correct,
                        you receive <strong>0 points</strong> for this category.
                    </p>

                    <div className="rules-image">
                        <img
                            src="/mexico-england.png"
                            alt="Exact score prediction example"
                        />
                    </div>
                </section>


                <section className="rules-section">
                    <h2>⏱️ Correct Half-time Result</h2>

                    <p>
                        You receive <strong>1 point</strong> if your predicted
                        half-time result is correct:
                    </p>

                    <ul>
                        <li><strong>1</strong> — Home team leads</li>
                        <li><strong>X</strong> — Draw</li>
                        <li><strong>2</strong> — Away team leads</li>
                    </ul>

                    <p>
                        You do not need to predict the exact half-time score.
                        Only the outcome matters.
                    </p>

                    <p>
                        For example, predicting <strong>X</strong> is correct
                        if the half-time score is either 0:0, 1:1, 2:2, etc.
                    </p>
                </section>


                <section className="rules-section">
                    <h2>➖ Correct Goal Difference</h2>

                    <p>
                        You receive <strong>1 point</strong> if you correctly
                        predict the goal difference between the two teams.
                    </p>

                    <p>
                        You do not need to predict the exact final score.
                    </p>

                    <p>
                        For example, if you predict Norway to win 2:1 and
                        the match ends 3:2, your prediction is still correct
                        because Norway won by exactly one goal in both cases.
                    </p>

                    <div className="rules-image">
                        <img
                            src="/norway-senegal.png"
                            alt="Correct goal difference example"
                        />
                    </div>

                    <h3>4 or more goals difference</h3>

                    <p>
                        There is a special rule for large goal differences.
                        If you predict a victory by
                        <strong> 4 or more goals</strong>, and the actual
                        difference is also 4 or more goals, you receive
                        <strong> 2 points</strong>.
                    </p>

                    <p>
                        This rule encourages users to make bold predictions
                        when they believe a team will win by a very large
                        margin.
                    </p>

                    <div className="rules-image">
                        <img
                            src="/germany-curacao.png"
                            alt="Large goal difference example"
                        />
                    </div>
                </section>


                <section className="rules-section">
                    <h2>💡 Tips</h2>

                    <ul>
                        <li>
                            Every prediction can earn points from multiple categories.
                        </li>

                        <li>
                            You don't need to get the exact score right to earn points.
                        </li>

                        <li>
                            You can still earn points by correctly predicting the half-time result, goal difference, or match outcome.
                        </li>

                        <li>
                            Correctly predicting unlikely results can earn
                            significantly more outcome points.
                        </li>

                        <li>
                            Think carefully about both the final score and
                            the half-time result.
                        </li>

                        <li>
                            Don't forget to submit your prediction before
                            kick-off.
                        </li>
                    </ul>
                </section>


                <section className="rules-section rules-final">
                    <h2>🏆 That's it!</h2>

                    <p>
                        Make your predictions, compete with your friends,
                        and see who can read the game best.
                    </p>

                    <p>
                        The more accurate — and the more unexpected —
                        your predictions are, the more points you can earn.
                    </p>
                </section>

            </div>
        </div>
    );
};

export default Rules;